module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "fm-title",
    attrs: {
      "id": "fm-2"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_xvii"
    }
  }, [_c('strong', [_vm._v("LIST OF ILLUSTRATIONS")])])]), _c('a', {
    attrs: {
      "id": "page_xvii"
    }
  }), _c('p', {
    staticClass: "toc-fig"
  }, [_c('a', {
    attrs: {
      "id": "page_xvii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/011_Chapter01#fig_1"
    }
  }, [_c('em', [_vm._v("Augustus")]), _vm._v(" (Philip Gendreau)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fig"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter01#fig_2"
    }
  }, [_c('em', [_vm._v("Tiberius")]), _vm._v(" (Philip Gendreau)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fig"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter01#fig_3"
    }
  }, [_c('em', [_vm._v("Claudius")]), _vm._v(" (P.I.P. Photos by Radio Times Hulton Picture Library)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fig"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter01#fig_4"
    }
  }, [_c('em', [_vm._v("Nero")]), _vm._v(" (P.I.P. Photos by Radio Times Hulton Picture Library)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fig"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter01#fig_5"
    }
  }, [_c('em', [_vm._v("Vespasian")]), _vm._v(" (P.I.P. Photos by Radio Times Hulton Picture Library)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fig"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter01#fig_6"
    }
  }, [_c('em', [_vm._v("Titus")]), _vm._v(" (British Museum)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fig"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter01#fig_7"
    }
  }, [_c('em', [_vm._v("Domitian")]), _vm._v(" (P.I.P. Photos by Radio Times Hulton Picture Library)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fig"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter01#fig_8"
    }
  }, [_c('em', [_vm._v("Alexander the Great")]), _vm._v(" (P.I.P. Photos by Radio Times Hulton Picture Library)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fig"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter01#fig_9"
    }
  }, [_c('em', [_vm._v("The Cyrus Cylinder")]), _vm._v(" (The British Museum)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fig"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter01#fig_10"
    }
  }, [_c('em', [_vm._v("Ruins of the Herodium")]), _vm._v(" (William Sanford LaSor)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fig"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter01#fig_11"
    }
  }, [_c('em', [_vm._v("Coins from the Time of Herod Agrippa")]), _vm._v(" (William Sanford LaSor)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fig"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter01#fig_12"
    }
  }, [_c('em', [_vm._v("Aerial view of Masada")]), _vm._v(" (Israel Government Tourist Office)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02#fig_13",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Ruins of the Propylaea")]), _vm._v(" (Philip Gendreau)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02#fig_14",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Aerial view of the Colosseum")]), _vm._v(" (Italian State Tourist Office)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02#fig_15",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Interior view of the Colosseum")]), _vm._v(" (Philip Gendreau)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02#fig_16",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("The Via Appia and Claudian oqueduct")]), _vm._v(" (Ewing Galloway)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter03#fig_17",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Ruins of the temple of Olympian Zeus")]), _vm._v(" (Philip Gendreau)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter03#fig_18",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Interior of the Pantheon")]), _vm._v(" (Screen Traveler, from Philip Gendreau)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter03#fig_19",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Incantation bowl")]), _vm._v(" (Royal Ontario Museum, Toronto)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter03#fig_20",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Plato")]), _vm._v(" (P.I.P. Photos by Radio Times Hulton Picture Library)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter04#fig_21",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Antiochus Epiphanes")]), _vm._v(" (P.I.P. Photos by Radio Times Hulton Picture Library)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter04#fig_22",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Modelo/Herod’s Temple by M. Avi-Yonah")]), _vm._v(" (William Sanford LaSor)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter04#fig_23",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Page from the Codex Vaticanus")]), _vm._v(" (P.I.P. Photos by Radio Times Hulton Picture Library)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter04#fig_24",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Page from Codex Sinaiticus")]), _vm._v(" (P.I.P. Photos by Radio Times Hulton Picture Library)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter04#fig_25",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Page from the Codex Alexandrinus")]), _vm._v(" (P.I.P. Photos by Radio Times Hulton Picture Library)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter04#fig_26",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("The Dead Sea and Mountains of Moab")]), _vm._v(" (The Matson Photo Service)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter04#fig_27",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Part of the Book of Isaiah from the Dead Sea Scrolls")]), _vm._v(" (Philip Gendreau)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter04#fig_28",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("The caves near the Dead Sea in which scrolls were found")]), _vm._v(" (The Matson Photo Service)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05#fig_29",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Fragment of the Damascus Document")]), _vm._v(" (Cambridge University Library)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/018_Chapter07#fig_30",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Leaf from Lindisfarne Gospels")]), _vm._v(" (British Museum)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Chapter08#fig_31",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("The Jordan River")]), _vm._v(" (Philip Gendreau)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Chapter08#fig_32",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Mount Tabor")]), _vm._v(" (William Sanford LaSor)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/020_Chapter09#fig_33",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Illuminated manuscript of Mark")]), _vm._v(" (The University of Michigan Library)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/021_Chapter10#fig_34",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("The Mount of Olives")]), _vm._v(" (William Sanford LaSor)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/022_Chapter11#fig_35",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Bodmer Papyrus II, showing John")]), _vm._v(" 6:59–70 (Bodmer Library, Geneva)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/023_Chapter12#fig_36",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("The Garden Tomb")]), _vm._v(" (by Burton Holmes, from Ewing Galloway)")]), _c('a', {
    attrs: {
      "id": "page_xviii"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_xviii"
    }
  }), _c('p', {
    staticClass: "toc-fig"
  }, [_c('a', {
    attrs: {
      "id": "page_xviii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/023_Chapter12#fig_37",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("One of the sources of the Jordan River")]), _vm._v(" (Ewing Galloway)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/023_Chapter12#fig_38",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Aerial view of Jordan River")]), _vm._v(" (William Sanford LaSor)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/023_Chapter12#fig_39",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("The hill country of Judah")]), _vm._v(" (A. Denis Baly)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/023_Chapter12#fig_40",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Tiberias on the Sea of Galilee")]), _vm._v(" (Philip Gendreau)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/023_Chapter12#fig_41",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Ruins of synagogue of Capernaum")]), _vm._v(" (Consulate General of Israel in New York)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/023_Chapter12#fig_42",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Ruins of Bethany")]), _vm._v(" (The Matson Photo Service)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/023_Chapter12#fig_43",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Garden of Gethsemane")]), _vm._v(" (Philip Gendreau)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/023_Chapter12#fig_44",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Aerial view of Jerusalem")]), _vm._v(" (The Matson Photo Service)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/023_Chapter12#fig_45",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Mount Zion")]), _vm._v(" (Ewing Galloway)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/026_Chapter14#fig_46",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Hellenistic round tower at Samaria")]), _vm._v(" (Israel Department of Antiquities and Museums)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/026_Chapter14#fig_47",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("The street called “Straight”")]), _vm._v(" (Ewing Galloway)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/027_Chapter15#fig_48",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Antioch")]), _vm._v(" (The Matson Photo Service)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/028_Chapter16#fig_49",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("The Arch of Titus")]), _vm._v(" (B. K. Condit)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/028_Chapter16#fig_50",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("The Parthenon on the Acropolis")]), _vm._v(" (Philip Gendreau)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/028_Chapter16#fig_51",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("The Theseum")]), _vm._v(" (Philip Gendreau)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/028_Chapter16#fig_52",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("General view of the Acropolis")]), _vm._v(" (Ewing Galloway)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/028_Chapter16#fig_53",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("The Erechtheum with the Porch of the Maidens")]), _vm._v(" (Philip Gendreau)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/028_Chapter16#fig_54",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Remains of the ancient Agora of Corinth")]), _vm._v(" (Ewing Galloway)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/028_Chapter16#fig_55",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("The Agora at Ephesus")]), _vm._v(" (B. K. Condir)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/029_Chapter17#fig_56",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Ruins of ancient Caesarea on the sea-coast")]), _vm._v(" (The Matson Photo Service)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/029_Chapter17#fig_57",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Ruins of the temple of Telesterion at Eleusis")]), _vm._v(" (B. K. Condit)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/029_Chapter17#fig_58",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Drawing of an ancient Roman ship")]), _vm._v(" (Ewing Galloway)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/029_Chapter17#fig_59",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("The Roman Forum")]), _vm._v(" (Philip Gendreau)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/031_Chapter18#fig_60",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("The Temple of Apollo at Bassae")]), _vm._v(" (Philip Gendreau)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/032_Chapter19#fig_61",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("The ancient amphitheater of Epidauros")]), _vm._v(" (Philip Gendreau)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/032_Chapter19#fig_62",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Tombs in early Christian cemetery at Salona")]), _vm._v(" (Philip Gendreau)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/033_Chapter20#fig_63",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Corinthian capital from the synagogue of Capernaum")]), _vm._v(" (The Matson Photo Service)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/035_Chapter22#fig_64",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Albrecht Dürer’s “The Apocalypse: the Four Horsemen”")]), _vm._v(" (National Gallery of Art, Washington, D.C.)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/035_Chapter22#fig_65",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("The island of Patmos")]), _vm._v(" (Denis Baly)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/035_Chapter22#fig_66",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("The great altar of Zeus at Pergamum")]), _vm._v(" (P.I.P. Photos by Radio Times Hulton Picture Library)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/035_Chapter22#fig_67",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Silver denarius of Tiberius")]), _vm._v(" (Ewing Galloway)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/038_Chapter24#fig_68",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Section of Gospel of John from the Codex Sinaiticus")]), _vm._v(" (British Museum)")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21cd996a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/007_Illustration.vue
// module id = 75
// module chunks = 0